import { useEffect, useState } from 'react';

import { getFooterStyle } from '../lib';

export const OneBtnFooter = ({ text, handleClick, isValid, disabled, btnStyle = 'gradient-btm' }) => {
  const getClassName = () => {
    if (isValid) return 'btm-btn-primary';
    if (disabled) return 'btm-btn-secondary btn-disabled';
    return 'btm-btn-secondary';
  };
  return (
    <div className={`btm-area ${btnStyle}`}>
      <button
        className={`btn ${getClassName()}`}
        onClick={() => {
          handleClick();
        }}
        disabled={disabled}
      >
        <span className='btn-txt-01'>{text}</span>
      </button>
    </div>
  );
};
export const SaveSkipFooter = ({
  text = '저장 후 다음',
  skipText = '건너뛰기',
  handleClick,
  handleSkip,
  isValid,
  btnStyle = 'gradient-btm',
  buttonStyle = 'btm-btn-primary',
}) => {
  return (
    <div className={`btm-area ${btnStyle}`}>
      <button className={`btn ${buttonStyle}`} onClick={handleClick} type='submit' disabled={!isValid}>
        <span className='btn-txt-01'>{text}</span>
      </button>
      {/* <div className='skip-wrap'>
        <button type='button' className='skip-btn' onClick={handleSkip}>
          {skipText}
        </button>
      </div> */}
    </div>
  );
};

export const TwoBtnFooter = ({ prevText, nextText, handlePrev, handleNext, isValid }) => {
  return (
    <div className='btm-area gradient-btm multi-btm'>
      <button
        className={`btn btm-btn-secondary`}
        onClick={() => {
          handlePrev();
        }}
      >
        <span className='btn-txt-01'>{prevText}</span>
      </button>

      <button
        className={`btn ${isValid ? 'btm-btn-primary' : 'btm-btn-secondary btn-disabled'}`}
        onClick={() => {
          handleNext();
        }}
        disabled={!isValid}
      >
        <span className='btn-txt-01'>{nextText}</span>
      </button>
    </div>
  );
};

export const FileOnlyBtn = ({ text, handleClick, disabled, isValid }) => {
  const [style, setStyle] = useState(null);

  const calcStyles = () => {
    const { area, secondary, text: textStyle } = getFooterStyle(window.innerWidth);
    setStyle({ area, secondary, text: textStyle });
  };

  useEffect(() => {
    calcStyles();
  }, []);

  return (
    style && (
      <div className='btm-area gradient-btm' style={style.area}>
        <button
          className={`btn ${disabled ? 'btm-btn-secondary btn-disabled' : 'btm-btn-primary'}`}
          onClick={() => {
            handleClick();
            window.scrollTo(0, 0);
          }}
          style={style.secondary}
          disabled={!isValid}
        >
          <span className='btn-txt-01' style={style.text}>
            {text}
          </span>
        </button>
      </div>
    )
  );
};
